import { AxiosResponse } from "axios"

import { request } from "../../request"

type GetValuationData = {
  email: string
}

export const getValuationLimit = async (
  getValuationData: GetValuationData
): Promise<AxiosResponse<string>> => {
  return request({
    url: "/api/v1/allow-valuation",
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
    },
    data: getValuationData,
  })
}
